<template>
  <v-dialog
    ref="dialog"
    v-model="menu"
    :return-value.sync="time"
    persistent
    width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="formatedTime"
        :label="label"
        outlined
        dense
        prepend-inner-icon="mdi-clock-time-four-outline"
        readonly
        :rules="getRules"
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-time-picker
      v-if="menu"
      v-model="time"
      full-width
      format="ampm"
      ampm-in-title
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false">
        Cancel
      </v-btn>
      <v-btn text color="primary" @click="$refs.dialog.save(time)">
        OK
      </v-btn>
    </v-time-picker>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { getRules } from "../assets/js/common";
export default {
  props: {
    value: {},
    label: {
      default: "",
    },
    endAt: {},
    disabled: {},
    rules: {
      type: String,
    },
    customRules: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data() {
    return {
      time: "",
      menu: false,
    };
  },
  computed: {
    getRules() {
      let { customRules, rules } = this;
      if (customRules.length > 0) return customRules;
      if (rules) return getRules(rules);
      return [];
    },
    formatedTime() {
      if (this.time) return moment(this.time, "HH:mm").format("hh:mm a");
      return "";
    },
  },
  watch: {
    value() {
      if (this.value) this.time = this.value;
    },
    time(val) {
      this.$emit("input", val);
    },
  },
  beforeMount() {
    if (this.value) this.time = this.value;
  },
};
</script>

<style></style>
